
/**
 * tlc.ls2kids.controls.JSIScroll
 */
export class JSIScroll {
	constructor(selector) {
		this.$wrapper = $(selector);
		this.$element = $(this.$wrapper.children().get(0));

		this._events = {};

		// indicators are not suppported (yet)
		this.indicators = [];

		// dont' support y
		this.currentPage = {
			pageX: 0,
			x: 0
		};

		this.isInTransition = false;

		this.refresh();
	}
	refresh() {
		this._refreshDimensions();

		this.$element.css({
			"position": "absolute"
		});

		this.totalPages = Math.ceil(this.dimensions.element.width / this.dimensions.wrapper.width);

		var i = 0;

		this.pages = [];

		for (; i < this.totalPages; i += 1) {
			this.pages.push({
				x: -this.dimensions.wrapper.width * i
			});
		}

		var goToPage = this.currentPage.pageX;

		if (goToPage >= this.pages.length) {
			goToPage = this.pages.length - 1;
		}

		this.goToPage(goToPage, 0, 0);
	}
	_refreshDimensions() {
		this.dimensions = {
			wrapper: {},
			element: {}
		};

		this.dimensions.wrapper.width = this.$wrapper.width();
		this.dimensions.element.width = this.$element.width();

		//	this.dimensions.height = this.$element.height();
	}
	prev() {
		this.goToPage(this.currentPage.pageX - 1);
	}
	next() {
		this.goToPage(this.currentPage.pageX + 1);
	}
	/**
	 *
	 * @param  {number} pageX the page number to navigate to
	 * @param {*=} pageY a placeholder, the real iScroll allows paging on the Y axis, this implementation does not.
	 * @param {*=} duration the time it takes to animate
	 */
	goToPage(pageX, pageY, duration) {
		duration = duration !== undefined ? duration : 500;

		function finished() {
			_this.currentPage.pageX = pageX;
			_this.currentPage.x = _this.pages[pageX].x;

			_this._execEvent('scrollEnd');
		}

		if (this.isInTransition) {
			return;
		}

		var _this = this;

		if (pageX < this.pages.length && pageX > -1) {
			var css = {
				"left": this.pages[pageX].x
			};

			if (duration > 0) {
				this.isInTransition = true;

				this.$element.animate(css,
					{
						duration: duration,
						complete: function () {
							_this.isInTransition = false;

							finished();
						}
					}
				);
			} else {
				window.requestAnimationFrame(function () {
					_this.$element.css(css);

					finished();
				});
			}
		}
	}
	scrollToElement(el, time, offsetX, offsetY, easing) { }
	on(event, callback, context) {
		context = context || this;

		if (!this._events[event]) {
			this._events[event] = [];
		}

		this._events[event].push({
			callback: callback,
			context: context
		});
	}
	_execEvent(type) {
		if (!this._events[type]) {
			return;
		}

		var i = 0, l = this._events[type].length;

		if (!l) {
			return;
		}

		for (; i < l; i++) {
			var event = this._events[type][i];
			event.callback.apply(event.context || this, [].slice.call(arguments, 1));
		}
	}
}








